import { forwardRef } from "react";
import styles from "./displayContainer.module.css";

const DisplayContainer = forwardRef(({ children, className = "" }, ref) => {
  return (
    <div className={`${styles.container} ${className}`.trim()} ref={ref}>
      {children}
    </div>
  );
});

export default DisplayContainer;
